import React from 'react';
import { classNames } from '@/lib/format';

const STATUS_MAP = {
  pending: { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-200' },
  sent: { bg: 'bg-sky-50', text: 'text-sky-700', border: 'border-sky-200' },
  opened: { bg: 'bg-sky-50', text: 'text-sky-700', border: 'border-sky-200' },
  'in progress': { bg: 'bg-amber-50', text: 'text-amber-800', border: 'border-amber-200' },
  in_progress: { bg: 'bg-amber-50', text: 'text-amber-800', border: 'border-amber-200' },
  submitted: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  expired: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
  active: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  inactive: { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-200' },
  on_hold: { bg: 'bg-amber-50', text: 'text-amber-800', border: 'border-amber-200' },
  rejected: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
  completed: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  auto_submitted: { bg: 'bg-sky-50', text: 'text-sky-800', border: 'border-sky-200' },
  abandoned: { bg: 'bg-amber-50', text: 'text-amber-900', border: 'border-amber-300' },
  scheduled: { bg: 'bg-sky-50', text: 'text-sky-700', border: 'border-sky-200' },
  revoked: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
  consumed: { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-300' },
  disabled: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
  default: { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-200' },
};

const LABEL_MAP = {
  active: 'Active', inactive: 'Inactive', pending: 'Pending', disabled: 'Disabled',
  sent: 'Sent',
  in_progress: 'In Progress', submitted: 'Submitted', expired: 'Expired', revoked: 'Revoked',
  consumed: 'Consumed',
  scheduled: 'Scheduled', completed: 'Completed', on_hold: 'On hold', rejected: 'Rejected', opened: 'Opened',
  abandoned: 'Abandoned', auto_submitted: 'Auto Submitted',
};

export const StatusPill = ({ status, children, size = 'md' }) => {
  const key = (status || '').toString().toLowerCase().replace(/-/g, '_');
  const c = STATUS_MAP[key] || STATUS_MAP[key.replace('_', ' ')] || STATUS_MAP.default;
  const padding = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
  return (
    <span data-testid="status-pill" className={classNames('inline-flex items-center justify-center rounded-full border font-medium', padding, c.bg, c.text, c.border)}>
      {children || LABEL_MAP[key] || status}
    </span>
  );
};

export const RecommendationPill = ({ label }) => {
  const map = {
    'Strong Recommend': 'bg-emerald-600 text-white border-emerald-700',
    'Recommend': 'bg-sky-600 text-white border-sky-700',
    'Neutral': 'bg-amber-500 text-white border-amber-600',
    'Not Recommended': 'bg-rose-600 text-white border-rose-700',
  };
  const cls = map[label] || 'bg-slate-700 text-white border-slate-800';
  return (
    <span data-testid="recommendation-pill" className={classNames('inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold tracking-tight', cls)}>
      {label}
    </span>
  );
};
